import React, { Fragment } from 'react';
import Navbar2 from '../../components/Navbar2';
import PageTitle from '../../components/pagetitle';
import ProjectSingle from '../../components/ProjectSingle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import { useParams } from 'react-router-dom';
import projectData from '../../data/projects.json'; 

const ProjectSinglePage = () => {
    const { slug } = useParams();
    
    // Find the current project
    const currentProject = projectData.projects.find(project => project.slug === slug);
    
    return (
        <Fragment>
            <Navbar2/>
            <PageTitle 
                pageTitle={currentProject ? currentProject.title : 'Project Not Found'} 
                pagesub={currentProject ? 'Project Details' : 'Error'} 
            /> 
            <ProjectSingle/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ProjectSinglePage;